import { Station, StationsApiFactory } from '@/api'
import { BaseMasterListRequest } from '@/requests/baseRequest'
import { AxiosPromise } from 'axios'
/**
 * 駅名一覧取得処理
 */
export class ListRequest extends BaseMasterListRequest {
  lineCode: string | undefined
  constructor(lineCode?: string) {
    super()
    this.lineCode = lineCode
  }
  protected request(): AxiosPromise<Array<Station>> {
    const api = StationsApiFactory()
    return api.stationsList(this.lineCode)
  }
}
